export const VehicleType = {
    CAR: 'CAR',
    TRUCK: 'TRUCK',
    MOTORCYCLE: 'MOTORCYCLE',
    BUS: 'BUS',
    UTILITY: 'UTILITY',
    OTHER: 'OTHER',
} as const satisfies Record<string, string>;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];

export const CostType = {
    VEHICLE_DETRAN: 'VEHICLE_DETRAN',
    VEHICLE_REGISTRY: 'VEHICLE_REGISTRY',
    VEHICLE_RTR: 'VEHICLE_RTR',
    VEHICLE_B3: 'VEHICLE_B3',
    VEHICLE_RTR_RELEASE: 'VEHICLE_RTR_RELEASE',
} as const satisfies Record<string, string>;

export type CostType = typeof CostType[keyof typeof CostType];

export interface VehicleOwner {
    personId: string;
    name: string;
    document: string;
}

export interface VehicleCost {
    id?: number;
    costType: CostType;
    value: number;
    costDate: string;
    registrationNumber?: string;
    registrationDate?: string;
    description?: string;
}

export interface VehicleValuation {
    marketValue: number;
    eligibleValue: number;
    monthlyRate: number;
    sourceName: string;
    valuationDate: string;
}

export interface VehicleListItem {
    id: string;
    name: string;
    vehicleType: VehicleType;
    vehicleTypeFormatted: string;
    brand: string;
    model: string;
    chassis: string;
    renavam: string;
    plate: string;
    plateState: string;
    yearManufacture: number;
    yearModel: number;
    color: string | null;
    archived: boolean;
    ownerName: string;
    ownerDocument: string;
    createdAt: string;
    updatedAt: string;
}

export interface VehicleDetail extends VehicleListItem {
    description: string | null;
    comments: string | null;
    owner: VehicleOwner;
    costs: VehicleCost[];
}

export const VEHICLE_TYPE_OPTIONS = [
    { value: VehicleType.CAR, label: 'Carro' },
    { value: VehicleType.TRUCK, label: 'Caminhão' },
    { value: VehicleType.MOTORCYCLE, label: 'Motocicleta' },
    { value: VehicleType.BUS, label: 'Ônibus' },
    { value: VehicleType.UTILITY, label: 'Utilitário' },
    { value: VehicleType.OTHER, label: 'Outro' },
];

export const COST_TYPE_OPTIONS = [
    { value: CostType.VEHICLE_DETRAN, label: 'DETRAN' },
    { value: CostType.VEHICLE_REGISTRY, label: 'Registradora' },
    { value: CostType.VEHICLE_RTR, label: 'RTR' },
    { value: CostType.VEHICLE_B3, label: 'Gravame B3' },
    { value: CostType.VEHICLE_RTR_RELEASE, label: 'Baixa RTR' },
];
